module.exports = __webpack_public_path__ + "img/s_8.ea02f65b.png";